import { render, staticRenderFns } from "./myDonateDetail.vue?vue&type=template&id=8ae90f66&scoped=true&"
import script from "./myDonateDetail.vue?vue&type=script&lang=js&"
export * from "./myDonateDetail.vue?vue&type=script&lang=js&"
import style0 from "./myDonateDetail.vue?vue&type=style&index=0&id=8ae90f66&prod&lang=less&scoped=true&"
import style1 from "./myDonateDetail.vue?vue&type=style&index=1&id=8ae90f66&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae90f66",
  null
  
)

export default component.exports